/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const AdminClusterUnWhitelist = {
  id: 'admin-cluster-unwhitelist.delete',
  tag: 'Admin',
  summary: 'Unwhitelist orphans clusters',
  description: 'Unwhitelist orphan clusters',
  method: 'delete',
  flags: { isAuthorized: true, isSuperuser: true },
  request: {
    query: z.strictObject({
      workspaceId: z.string(),
      customerId: z.string(),
      clusterId: z.string(),
    }),
  },
  route: () => `/administration/cluster/whitelist`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
